const ErrorStroked = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='100'
    height='100'
    fill='none'
    viewBox='0 0 100 100'
  >
    <path
      fill='#D00A00'
      fillRule='evenodd'
      d='M.5 50C.5 22.676 22.675.5 50 .5 77.324.5 99.5 22.676 99.5 50S77.324 99.5 50 99.5C22.675 99.5.5 77.324.5 50ZM50 3.5C24.332 3.5 3.5 24.332 3.5 50S24.332 96.5 50 96.5c25.667 0 46.5-20.832 46.5-46.5S75.667 3.5 50 3.5ZM30.572 30.572a7.06 7.06 0 0 1 9.993 0l9.434 9.435 9.435-9.435a7.06 7.06 0 0 1 9.993 0 7.06 7.06 0 0 1 0 9.993L59.992 50l9.435 9.435a7.06 7.06 0 0 1 0 9.992 7.06 7.06 0 0 1-9.993 0L50 59.993l-9.434 9.434a7.06 7.06 0 0 1-9.993 0 7.06 7.06 0 0 1 0-9.992L40.006 50l-9.434-9.435a7.06 7.06 0 0 1 0-9.993Zm7.871 2.121a4.06 4.06 0 0 0-5.75 0 4.06 4.06 0 0 0 0 5.75L44.249 50 32.693 61.556a4.06 4.06 0 0 0 0 5.75 4.06 4.06 0 0 0 5.75 0L50 55.75l11.556 11.556a4.06 4.06 0 0 0 5.75 0 4.06 4.06 0 0 0 0-5.75L55.75 50l11.556-11.556a4.06 4.06 0 0 0 0-5.75 4.06 4.06 0 0 0-5.75 0L49.998 44.248 38.443 32.694Z'
      clipRule='evenodd'
    />
  </svg>
)

export default ErrorStroked
